<main class="container- pointer">

    <div class="row gx-0 gy-0 p-0 m-0">

        <div class="col-12">

            <div class="w-100 h-100 p-1x">

                <div class="uploader-container rounded w-100" (click)="fileInput.click()">
                   
                     <i class="fa fa-file-image-o" aria-hidden="true"></i>

                    <p class="my-2">فایل خود را از  <a href="javascript:void(0)">اینجا</a> انتخاب کنید.</p>

                    <input type="file" #fileInput [accept]="acceptTypes" hidden (change)="onFileSelected($event)">

                    <p class="text-muted text-center mb-1"> <small> فرمت های مجاز : {{ allowedFileTypes.join(', ') }} - حداکثر سایز : {{ maxFileSize / (1024 * 1024) | faNum }} مگابایت </small></p>

                    <p class="text-danger"> {{ errorMessage | faNum}}</p>

                </div>

                <ng-container *ngIf="selectedFile">

                    <div class="uploaded-file col-12 row gx-0 gy-0 mt-3 p-2">
    
                        <div class="col-md-1 col-2 justify-content-end">
    
                            <i class="fa fa-times" aria-hidden="true" (click)="removeFile()"></i>

                        </div>
    
                        <div class="col-md-10 col-8">
    
                            <p class="mb-0 text-muted text-end">
    
                                {{ selectedFile!.name }}
    
                            </p>
    
                        </div>
    
                        <div class="col-md-1 col-2 d-flex justify-content-end">
    
                            <i class="fa fa-file-image-o text-muted" aria-hidden="true"></i>
    
                        </div>
    
                    </div>

                </ng-container>

            </div>

        </div>

    </div>

</main>